/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
import lab from '../assets/img/lab_iconics_original_logo.png';
import lab_bg from '../assets/img/portfolio/main.png';
import thumbs from '../assets/img/testimonial_10423394.png';
import { v4 as uuidv4 } from "uuid";
import axios from 'axios';
import ErrorPopup from './ErrorPopup';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

const SaasSubscribeForm = () => {

    const [cusDetails , setCusDetails] = useState({
        firstName : '',
        lastName : '',
        contactNo : '',
        email : '',
        companyName : '',
        // industry : '',
        address : '',
        message : ''
    });
    const [errors, setErrors] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    // const [getVerify, setGetVerify] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    const [otpExpired, setOtpExpired] = useState(false);
    const [invalidID, setInvalidID] = useState(false);
    const [invalidOTP, setInvalidOTP] = useState(false);
    const [otp, setOtp] = useState(Array(6).fill(''));
    const [otpEmail, setOtpEmail] = useState('');
    const [resendOTP, setResendOTP] = useState(false);
    const inputsRef = useRef([]);

    const [timeLeft, setTimeLeft] = useState(180); 
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [newCustomerDetails, setNewCustomerDetails] = useState(null); 
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errorPopup, setErrorPopup] = useState({
        isOpen: false,
        message: '',
        type: 'error'
    });
    const navigate = useNavigate();

    const showErrorPopup = (message, type = 'error') => {
        setErrorPopup({
            isOpen: true,
            message,
            type
        });
    };

    const closeErrorPopup = () => {
        setErrorPopup({
            ...errorPopup,
            isOpen: false
        });

        if (errorPopup.type === 'critical') {
            navigate('/'); 
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!cusDetails.firstName.trim()) newErrors.firstName = 'Please enter your first name';
        if (!cusDetails.lastName.trim()) newErrors.lastName = 'Please enter your last name';
        if (!cusDetails.email.trim()) {
            newErrors.email = 'Please enter your email';
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(cusDetails.email)) {
            newErrors.email = 'Please enter a valid email';
        }
        if (!cusDetails.contactNo.trim()) newErrors.contactNo = 'Please enter your contact number';
        if (!cusDetails.companyName.trim()) newErrors.companyName = 'Please enter your company name';
        // if (!cusDetails.industry.trim()) newErrors.industry = 'Please enter your industry';
        if (!cusDetails.address.trim()) newErrors.address = 'Please enter your address';
        // if (!cusDetails.message.trim()) newErrors.message = 'Please enter your message';
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (value, prop) => {
        if (prop === 'firstName' || prop === 'lastName') {
            if (value.length > 30) return;
        } else if (prop === 'contactNo') {
            if (!/^\d*$/.test(value)) return;
            if (value.length > 10) return;
        } else if (prop === 'email') {
            const isValidEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
            setErrors(prevErrors => ({
                ...prevErrors,
                email: isValidEmail || value === '' ? '' : 'Please enter a valid email.'
            }));
        } else {
            if (value.length > 100) 
                return;
        }
        setCusDetails(prevState => ({
            ...prevState,
            [prop]: value,
        }));
    }

    const handleForm = async () => {
        if (validateForm()) {
            const newCusDetails = {
                ...cusDetails,
                id : getUUID()
            }
            setNewCustomerDetails(newCusDetails);
            setOtpEmail(cusDetails.email);
            setLoading(true);

            try {
                const apiUrl = process.env.REACT_APP_API_BASE_URL;
                const response = await axios.post(`${apiUrl}/security/sendOTP`, newCusDetails);
                setOtpExpired(false);
                setInvalidOTP(false);
                setInvalidID(false);
                if(response.data.success) {
                    // setGetVerify(true);
                    resetTimer();
                    setFormSubmitted(true);
                    setResendOTP(false);
                }
            } catch (error) {
                console.error('Error sending data:', error);
                
                if (error.response) {
                    const { data } = error.response;
                    
                    if (data.errorType === 'email') {
                        showErrorPopup('Unable to send verification email. Please try again later.');
                    } else if (data.errorType === 'validation') {
                        showErrorPopup('Please check all form fields and try again.');
                    } else {
                        showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
                    }
                } else if (error.request) {
                    showErrorPopup('Unable to connect to our services. Please check your internet connection and try again.', 'critical');
                } else {
                    showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
                }
            } finally {
                setLoading(false);
            }
        } else {
            // console.log("Not Submitted");
        }
    };

    const handleChange = (element, index) => {
        const value = element.value.replace(/[^0-9]/g, '');
        if (!value) return;
    
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
    
        if (index < 5) {
          inputsRef.current[index + 1].focus();
        }
    };
    
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            e.preventDefault();
            const newOtp = [...otp];
            newOtp[index] = '';
            setOtp(newOtp);
            if (index > 0) {
                inputsRef.current[index - 1].focus();
            }
        }
    };
    
    // const clearOTP = () => {
    //     setOtp(Array(6).fill(''));
    //     inputsRef.current[0].focus();
    // };

    const verifyOTP = async() => {
        if(otp) {
            const enteredOtp = otp.join('');
            setLoading(true);

            try {
                const apiUrl = process.env.REACT_APP_API_BASE_URL;
                const response = await axios.post(`${apiUrl}/security/verify-otp`, { email : otpEmail , otp : enteredOtp, id : newCustomerDetails.id});

                if(response.data.message === 'OTP expired' || response.data === 'OTP expired') {
                    setOtpExpired(true);
                    setOtp(Array(6).fill(''));
                    setResendOTP(false);
                    setInvalidOTP(false);
                    setInvalidID(false);
                } else if (response.data.message === 'Invalid OTP' || response.data === 'Invalid OTP') {
                    setInvalidOTP(true);
                    setOtp(Array(6).fill(''));
                    setResendOTP(false);
                    setInvalidID(false);
                }  else if (response.data.message === 'Invalid ID format' || response.data === 'Invalid ID format') {
                    setInvalidID(true);
                    setOtp(Array(6).fill(''));
                    setOtpExpired(false);
                    setInvalidOTP(false);
                    setResendOTP(false);
                } else {
                    setOtpVerified(true);
                    setOtpExpired(false);
                    setInvalidOTP(false);
                    setResendOTP(false);
                    setInvalidID(false);
                    try {
                        const customerDetails = {
                            email: cusDetails.email,
                            firstName: cusDetails.firstName,
                            lastName: cusDetails.lastName,
                            contact_no: cusDetails.contactNo,
                            company_name: cusDetails.companyName,
                            address: cusDetails.address,
                            message: cusDetails.message,
                        };
                        const apiUrl = process.env.REACT_APP_API_BASE_URL;
                        const response = await axios.post(`${apiUrl}/security/InsertUserDetails`, customerDetails);
                        setCusDetails({
                            firstName: '',
                            lastName: '',
                            contactNo: '',
                            email: '',
                            companyName: '',
                            address : '',
                            message : '',
                        });
                        setNewCustomerDetails(null);
                    } catch (error) {
                        showErrorPopup('Unable to save your information. Please try again later.');
                    }
                }
            } catch (error) {
                console.error(error);
                if (error.response) {
                    const { data } = error.response;
                    if (data.errorType === "invalid_otp") {
                        setInvalidOTP(true);
                        setOtp(Array(6).fill(''));
                        setResendOTP(false);
                        setOtpExpired(false);
                        setInvalidID(false);
                    } else if (data.errorType === "otp_expired") {
                        setOtpExpired(true);
                        setOtp(Array(6).fill(''));
                        setResendOTP(false);
                        setInvalidOTP(false);
                        setInvalidID(false);
                    } else if (data.errorType === "invalid_id") {
                        setInvalidID(true);
                        setOtpExpired(false);
                        setOtp(Array(6).fill(''));
                        setResendOTP(false);
                        setInvalidOTP(false);
                    } else {
                        showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
                    }
                } else if (error.request) {
                    showErrorPopup('Unable to connect to our services. Please check your internet connection and try again.', 'critical');
                } else {
                    showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleResendOTP = async() => {
        setLoading(true);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await axios.post(`${apiUrl}/security/resendOTP`, 
                {   email: otpEmail, 
                    id : newCustomerDetails.id, 
                    firstName: newCustomerDetails.firstName, 
                    lastName: newCustomerDetails.lastName  
                });
            if (response.data.success) {
                setResendOTP(true);
                setOtp(Array(6).fill(''));
                inputsRef.current[0].focus();
                setInvalidOTP(false);
                setOtpExpired(false);
                setInvalidID(false);
                resetTimer();
            }
        } catch (error) {
            console.error('Error resending OTP:', error);
            if (error.response) {
                const { data } = error.response;
                
                if (data.errorType === 'email') {
                    showErrorPopup('Unable to send verification email. Please try again later.');
                } else if (data.errorType === 'not_found') {
                    showErrorPopup('Your session has expired. Please restart the verification process.', 'critical');
                } else {
                    showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
                }
            } else if (error.request) {
                showErrorPopup('Unable to connect to our services. Please check your internet connection and try again.', 'critical');
            } else {
                showErrorPopup('We are experiencing technical difficulties. Please try again later.', 'critical');
            }
        } finally {
            setLoading(false);
        }
    }

    const getUUID = () => {
       return uuidv4();
    }

    const resetTimer = () => {
        if (invalidOTP || otpExpired) {
            setIsResendDisabled(false);
        }
        setTimeLeft(180);
        setIsTimerRunning(true);
        setIsResendDisabled(true);
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        let timerId;
        if (!otpVerified) {
        
            timerId = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerId);
                        setIsResendDisabled(false); 
                        setIsTimerRunning(false); 
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
    
        return () => clearInterval(timerId);
    }, [isTimerRunning, otpVerified]);

    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);

    // const handleVerification = () => {
    //     setGetVerify(prev => !prev);
    //     const v = getUUID();
    // }

    const sectionStyle = {
        backgroundImage: `url(${lab_bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        lineHeight: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        height : 'auto',
        paddingTop : '12vh'
    };

    return (<div className='portifoliobody'>
        <ErrorPopup
            message={errorPopup.message} 
            isOpen={errorPopup.isOpen} 
            onClose={closeErrorPopup} 
            type={errorPopup.type}
        />
        {loading && (
            <div id="loader" className="pageOverlay">
                <div className="lm-preload">
                    <div className="lm-item lm-item-1"></div>
                    <div className="lm-item lm-item-2"></div>
                    <div className="lm-item lm-item-3"></div>
                    <div className="lm-item lm-item-4"></div>
                    <div className="lm-item lm-item-5"></div>
                </div>
            </div>
        )}
        <main id="main">
            <section id="saas_form" className="about text-start" style={sectionStyle}>
                <div className="container" style={{display: 'flex', justifyContent:'center', alignItems:'center', height:'auto'}}>

                    <div className="section sub-form text-center" data-aos="zoom-out">
                        <div style={{color: '#084c68', fontSize:'25px', fontWeight:'600'}}>
                            Subscribe for Lab Iconics LIMS SaaS
                        </div>
                        <div className='image-div'>
                            <div className='imgage-in-div'>
                                <img src={lab} alt="" className='image-logo' />
                            </div>
                        </div>
                        {formSubmitted && !otpVerified && (
                            <div className="otp-container">
                                <h2>OTP Verification</h2>
                                <div>We have {resendOTP ? 'resent' : 'sent'} a 6-digit OTP to your email address.</div>
                                <br />
                                <div className="otp-inputs">
                                    {otp.map((data, index) => (
                                        <input
                                        key={index}
                                        ref={(el) => (inputsRef.current[index] = el)}
                                        type="text"
                                        maxLength="1"
                                        value={data}
                                        onChange={(e) => handleChange(e.target, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        className="otp-box"
                                        />
                                    ))}
                                </div>
                                {invalidOTP && (
                                    <> <br /> <p className="help is-danger">Entered OTP is Invalid</p> </>
                                )} 
                                {otpExpired && (
                                    <> <br /> <p className="help is-danger">OTP has Expired</p> </>
                                )}
                                {invalidID && (
                                    <><br /><p className="help is-danger">Invalid session. Please refresh the page or try again.</p></>
                                )}

                                <br />
                                
                                <div className='resend-otp' style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: timeLeft === 0 && !otpExpired && !invalidOTP && !invalidID ? 'center' : 'space-around',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '10px',
                                }}>
                                    {isTimerRunning && <div style={{ color: 'blue'}}>
                                        OTP expires in {formatTime(timeLeft)}
                                    </div>}

                                    {timeLeft === 0 && (
                                        <div style={{ color: 'red', fontSize: '0.75rem', textAlign: 'center' }}>
                                            OTP has expired. Please click "Resend OTP" to get a new one.
                                        </div>
                                    )}

                                    <div className='resend-btn' onClick={handleResendOTP}>
                                        Resend OTP
                                    </div>
                                </div>

                                <br />
                                <div className="otp-buttons">
                                    <RouterLink className="clear-btn routerLink" to='/' onClick={() => { 
                                        setFormSubmitted(false);
                                        setCusDetails({ firstName: '',lastName: '',contactNo: '',email: '',companyName: '', address: '', message:'' });
                                    }}>Cancel</RouterLink>
                                    <button className="verify-btn" onClick={verifyOTP} disabled={!isTimerRunning} style={{cursor:!isTimerRunning ? 'not-allowed' : 'pointer'}}>Verify</button>
                                </div>
                          </div>
                        )}
                        {formSubmitted && otpVerified && !otpExpired && !invalidOTP && (
                            <div className='form-details'>
                                <div>
                                    <img src={thumbs} alt="success icon" style={{height:'120px'}} />
                                    {/* <iframe src="https://lottie.host/embed/37d9a209-22c0-47df-b95c-3e6febd86f78/05U93JvRLY.lottie" title='success-icon'></iframe> */}
                                </div>
                                <div style={{color:'#084c68', fontSize:'22px', lineHeight:'1.5',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)'}}>
                                    Your pricing request has been successfully submitted. Lab Iconics team will get in touch with you.
                                </div>
                                <div style={{color:'#084c68', fontSize:'24px',textShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)'}}>
                                    Thank you.
                                </div>
                                <div style={{display:'flex', justifyContent:"center",alignItems:'center', margin:'20px 0 0 0'}}>
                                    <RouterLink to='/' className='sub-btns routerLink' >HOME</RouterLink>
                                </div>
                            </div>
                        )} 
                        {!formSubmitted && (
                            <div className="form-details">
                                <div className="cusotmer-name" style={{ display :'flex' , width:'100%', justifyContent:'center'}}>
                                    <div className='customer first_name'>
                                        <input type="text" placeholder='FIRST NAME' value={cusDetails.firstName} maxLength={30} onChange={(e) => handleInputChange(e.target.value, 'firstName')}/>
                                    {errors.firstName && <p className="help is-danger" style={{marginLeft:'6%'}}>{errors.firstName}</p>}
                                    </div>
                                    <div className='customer last_name'>
                                        <input type="text" placeholder='LAST NAME'value={cusDetails.lastName} maxLength={30} onChange={(e) => handleInputChange(e.target.value, 'lastName')}/>
                                    {errors.lastName && <p className="help is-danger" style={{marginLeft:'6%'}}>{errors.lastName}</p>}
                                    </div>
                                </div>
                                <div className="email inp-div">
                                    <input type="email" placeholder='EMAIL' value={cusDetails.email} onChange={(e) => handleInputChange(e.target.value,'email')}/>
                                    {errors.email && <p className="help is-danger">{errors.email}</p>}
                                </div>
                                {/* <div className="contact-num inp-div">
                                    <label htmlFor="contact-num">CONTACT NO : +91</label>
                                    <input type='tel' id='contact-num' placeholder='ENTER NUMBER' value={cusDetails.contactNo} maxLength={10} onChange={(e) => handleInputChange(e.target.value, 'contactNo')}/>
                                </div>
                                {errors.contactNo && <p className="help is-danger">{errors.contactNo}</p>} */}
                                <div className="contact-no inp-div">
                                    <input type="text" id='contact-num' placeholder='CONTACT NO' value={cusDetails.contactNo} maxLength={10} onChange={(e) => handleInputChange(e.target.value, 'contactNo')} />
                                    {errors.contactNo && <p className="help is-danger">{errors.contactNo}</p>}
                                </div>
                                <div className="company-name inp-div">
                                    <input type="text" placeholder='COMPANY NAME' value={cusDetails.companyName} maxLength={30} onChange={(e) => handleInputChange(e.target.value,'companyName')}/>
                                    {errors.companyName && <p className="help is-danger">{errors.companyName}</p>}
                                </div>
                                {/* <div className="industry-name inp-div">
                                    <input type="text" placeholder='INDUSTRY' value={cusDetails.industry} maxLength={30} onChange={(e) => handleInputChange(e.target.value,'industry')}/>
                                    {errors.industry && <p className="help is-danger">{errors.industry}</p>}
                                </div> */}
                                <div className="address inp-div">
                                    <input type="text" placeholder='ADDRESS' value={cusDetails.address} onChange={(e) => handleInputChange(e.target.value,'address')}/>
                                    {errors.address && <p className="help is-danger">{errors.address}</p>}
                                </div>
                                <div className="customer inp-div">
                                    <textarea className='msg-text-area' id="" cols="45" rows="5" placeholder='MESSAGE' value={cusDetails.message} onChange={(e) => handleInputChange(e.target.value,'message')}></textarea>
                                    {errors.message && <p className="help is-danger">{errors.message}</p>}
                                </div>
                                {/* <div className="verification-div">
                                    <input type="checkbox" id="verifyCheckbox" className="verify-checkbox" onChange={handleVerification} />
                                    <label htmlFor="verifyCheckbox" className="verify-label"> Get Verified </label>
                                </div> */}
                                <div className='form-btns-div'>
                                    <div className='sub-btns routerLink' onClick={()=> navigate(-1)} >BACK</div>
                                    <div className='sub-btns' onClick={handleForm}>SUBMIT REQUEST</div>
                                </div>
                            </div>
                        )}
                    </div>
                    
                </div>
            </section>
        </main>
    </div>
    );
};

export default SaasSubscribeForm;
